import { coreUsersByIdSalesforcePreferencesGetAsyncSlice } from './get';
import { coreUsersByIdSalesforcePreferencesPatchAsyncSlice } from './patch';

export const { requestGetCoreUsersByIdSalesforcePreferences, resetGetCoreUsersByIdSalesforcePreferences } =
	coreUsersByIdSalesforcePreferencesGetAsyncSlice.asyncActionCreators;

export const { requestPatchCoreUsersByIdSalesforcePreferences, resetPatchCoreUsersByIdSalesforcePreferences } =
	coreUsersByIdSalesforcePreferencesPatchAsyncSlice.asyncActionCreators;
